import React, { useState } from 'react';
import { Icon } from '@insticator/insticator-ui';
import injectSheet from 'react-jss';
import styles from './tooltips_styles';

const ControlsTooltips = injectSheet(styles)((props) => {
    const {
      order,
      bottomVisible,
      tooltipsContent,
      isChecked,
    } = props;

    const [visibleTooltip, setVisibleTooltip] = useState(false);

    const handleMouseEnter = () => {
      setVisibleTooltip(true)
    }

    const handleMouseLeave = () => {
      setVisibleTooltip(false)
    }

    return (
      <div
        key={order}
        className='controls-tooltips'
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {!isChecked ?
            <Icon name={`question-circle`}/> :
            <div className='empty'/>}

        {visibleTooltip && <div className='tooltip-wrapper'>
          <div className='top-tooltip'>{tooltipsContent[order].top}</div>
          {bottomVisible &&
              <div className='bottom-tooltip'>
                <img src={tooltipsContent[order].bottom} className='tooltips-image'/>
              </div>}
        </div>}
      </div>
    );
});
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ControlsTooltips;
